import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";
import { UtilService as util } from "../Services/UtilService";

const cardTemplate = 'VolunteerCard';
const modalTemplate = 'VolunteerCardModal';

export class VolunteerModule {
    static async Init(congregationId) {

        DEBUG && console.info('*--> Volunteer Module Init');

        var elements = document.querySelectorAll('[data-component="volunteer-cards"]');

        elements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var mode = element.getAttribute('data-mode');
            var opportunityId = element.getAttribute('data-opportunityId');
            var filter = element.getAttribute('data-filter');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info(`Mode:                    ${mode}`);
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`OpportunityID:           ${opportunityId}`);
            DEBUG && console.info(`Filter:                  ${filter}`);
            DEBUG && console.info('**************************************************');

            this.InitVolunteerCards(element, congregationId, mode, opportunityId, filter);
        });
    }

    // Init Cards
    static async InitVolunteerCards(element, congregationId, mode, opportunityId, filter) {
        let self = this;

        var data = await this.GetOpportunities(congregationId, mode);

        var templateData = { "data": data, "mode": `${mode}`, "oppModal": `modal${element.id}` };

        var content = await TemplateService.GetRenderedTemplate(cardTemplate, templateData);

        element.innerHTML = content;

        this.AddModalEvents(element.id);

        if (opportunityId) {
            const modalElement = document.getElementById(`modal${element.id}`);
            window.setTimeout(function () {
                self.LoadVolunteerCardModal(modalElement, opportunityId, true);
            }, 300);            
        }


        const btnVolFilterVolunteers = document.getElementById("btnVolFilterVolunteers");
        const btnVolFilterQuickserve = document.getElementById("btnVolFilterQuickserve");

        btnVolFilterQuickserve.addEventListener("click", function () {
            self.FilterVolCards(true);
        });

        btnVolFilterVolunteers.addEventListener("click", function () {
            self.FilterVolCards(false);
        });

        if (filter) {
            if (filter == 'vol') {
                btnVolFilterVolunteers.click();
            }

            if (filter === 'qs') {
                btnVolFilterQuickserve.click();
            }
        }
    }

    // Filter All Cards
    static FilterVolCards(quickserve) {

        const quickServeCards = document.querySelectorAll('[data-type="Quickserve"]');
        const volunteerCards = document.querySelectorAll('[data-type="Volunteer"]');

        if (quickserve) {
            this.hideElements(volunteerCards);
            this.showElements(quickServeCards);
        }
        else {
            this.showElements(volunteerCards);
            this.hideElements(quickServeCards);
        }
    }

    static hideElements(cardObjects) {
        cardObjects.forEach((o) => {
            o.style.display = 'none';
        });
    }

    static showElements(cardObjects) {
        cardObjects.forEach((o) => {
            o.style.display = 'block';
        });
    }

    // Add Modal Events
    static AddModalEvents(elementId) {
        const element = document.getElementById(`modal${elementId}`);
        element.addEventListener('show.bs.modal', (evt) => {

            try {
                DEBUG && console.log('Modal Called');

                const oppId = evt.relatedTarget.getAttribute('data-id');
                DEBUG && console.log(oppId);

                this.LoadVolunteerCardModal(element, oppId, false);

            }
            catch { }

        });

        element.addEventListener('shown.bs.modal', (evt) => {
            DEBUG && console.log('Modal now Shown');
        });
    }

    // Load Modal Window / Data
    static async LoadVolunteerCardModal(element, opportunityId, manualOpen) {

        // localize this
        let that = this;

        var data = await this.GetOpportunity(opportunityId);

        // User Check
        var user = util.getUserObj();

        // App Check
        var app = null;
        if (user) {
            app = await this.getVolunteerApp();

            // clear app if not setup
            if (app.Volunter_App_ID == 0) { 
                app = null;
            }
        }

        // Current URL with Opportunity ID Open
        const currentUrl = `${window.location.href}?opportunityId=${opportunityId}`;

        // Setup Data
        var modalData = { "data": data, "user": user, "app":app };
        DEBUG && console.info(modalData);

        var content = await TemplateService.GetRenderedTemplate(modalTemplate, modalData);
        const container = element.querySelector('.modal-content');

        container.innerHTML = content;

        // Init Buttons
        const btnLoginOpportunity = document.getElementById("btnLoginOpportunity");
        const btnSignUpVModal = document.getElementById("btnSignUpVModal");
        const modalVolunteerButtons = document.getElementById("modalVolunteerButtons");
        const btnApplyVModal = document.getElementById("btnApplyVModal");

        // Add Copy Button
        const btnCopy = document.getElementById("btnCopy");
        util.addCopyUrl(btnCopy, 'opportunityId', opportunityId);

        if (!user) {
            // Add btnOpportunityLogin Events
            btnLoginOpportunity.addEventListener('click', function () {               
                
                util.redirectToAuthentication(currentUrl);

            });
        }    

        if (user && app.Volunteer_App_ID == 0 && !data.Quickserve) {
            const btnJumpToApp = document.getElementById("btnJumpToApp");

            if (btnJumpToApp) {
                btnJumpToApp.addEventListener('click', function () {
                    that.JumpToVolunteerApp(data);
                });
            }
        }

        if (user && app.Volunteer_App_ID > 0 && !data.Quickserve) {
            const btnJumpToApp = document.getElementById("btnJumpToApp");

            if (btnJumpToApp) {
                btnJumpToApp.addEventListener('click', function () {
                    that.JumpToVolunteerApp(data);
                });
            }
        }


        // Setup Buttons
        if (user && data.Quickserve) {
            // Setup QuickServe Signup
            btnSignUpVModal.style.display = "inline-block";
            btnSignUpVModal.addEventListener("click", function () {
                that.QuickServeSignUp(opportunityId, element.id);
            });
        }

        if (user != null && app != null && app.Volunteer_App_Status_ID == 6 && !data.Quickserve) {
            // Setup Volunter App Apply
            btnApplyVModal.style.display = "inline-block";
            btnApplyVModal.addEventListener("click", function () {
                that.VolunteerSignUp(opportunityId, element.id);
            });
        }

        if (manualOpen) {
            util.openModal(`${element.id}`);
        }
    }

    //
    // Action: Apply to Volunteer App
    //
    static VolunteerSignUp(opportunityId, modalElementId) {
        api.postAuthenticatedData(`Volunteer/SignUp/${opportunityId}`)
            .then((data) => {
                // Close Modal
                util.closeModal(`${modalElementId}`);

                // Show Success Notify
                util.showSuccessToast('You have applied for a new volunteer position.', 7000, true);
            });
    }

    //
    // Action: Sign Up for QuickServe
    //
    static QuickServeSignUp(opportunityId, modalElementId) {
        api.postAuthenticatedData(`Volunteer/SignUp/${opportunityId}`)
            .then((data) => {
                // Close Modal
                util.closeModal(`${modalElementId}`);

                // Show Success Notify
                util.showSuccessToast('Quick Serve Signup was successful.', 7000, true);
            });
    }

    //
    // Action: Redirect to App
    //
    static JumpToVolunteerApp(opportunity) {
        api.getAuthenticatedData(`User/GetUserGuid`)
            .then((guid) => { 
                window.location.href = `https://vol.calvaryccm.com/app/programstart?congregationId=${opportunity.Congregation_ID}&programId=${opportunity.Program_ID}&userGuid=${guid.User_GUID}&oppId=${opportunity.Opportunity_ID}`;
            });            
    }

    //
    // Action: Redirect to Resume App
    //
    static JumpToResumeVolunteerApp() {
        api.getAuthenticatedData(`User/GetUserGuid`)
            .then((guid) => {
                window.location.href = `https://vol.calvaryccm.com/app/resume?userGuid=${guid.User_GUID}`;
            });
    }
    
    //
    // Data: Get Opportunities
    //
    static async GetOpportunities(congregationId, mode) {
        var data = await api.getData(`Volunteer/GetOpportunities?congregationId=${congregationId}`);
        DEBUG && console.info(data);
        return data;
    }

    //
    // Data: Get Opportunity
    //
    static async GetOpportunity(oppId) {
        var data = await api.getData(`Volunteer/GetOpportunity/${oppId}`);
        DEBUG && console.info(data);
        return data;
    }

    //
    // Data: Get VolunteerApp
    //
    static async getVolunteerApp() {
        var data = await api.getAuthenticatedDataAsync(`User/GetUserVolunteerApp`);
        DEBUG && console.info(data);
        return data;
    }
}